"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReanimatedBottomSheetFooter = void 0;
const react_1 = __importDefault(require("react"));
const bottom_sheet_1 = require("@gorhom/bottom-sheet");
const react_native_1 = require("react-native");
const react_native_device_info_1 = __importDefault(require("react-native-device-info"));
const ReanimatedBottomSheetContext_1 = require("../ReanimatedBottomSheetContext");
const atoms_1 = require("../../../atoms");
const shadowProps = {
    viewStyle: { width: '100%' },
    distance: 15,
};
const STATUS_BAR_HEIGHT = react_native_1.StatusBar.currentHeight || 25;
const DEFAULT_HEADER_HEIGHT = 68;
const HEADER_HEIGHT = react_native_device_info_1.default.hasNotch()
    ? STATUS_BAR_HEIGHT + DEFAULT_HEADER_HEIGHT
    : DEFAULT_HEADER_HEIGHT;
exports.ReanimatedBottomSheetFooter = (props) => {
    const { children, shadow = false } = props;
    const { state: { scrollableContentHeight }, } = ReanimatedBottomSheetContext_1.useReanimatedBottomSheet();
    const { height: windowHeight } = react_native_1.useWindowDimensions();
    const footerShadowVisibilityThreshold = windowHeight - HEADER_HEIGHT;
    const showShadow = shadow
        ? true
        : scrollableContentHeight > footerShadowVisibilityThreshold;
    return (react_1.default.createElement(bottom_sheet_1.BottomSheetFooter, Object.assign({}, props), showShadow ? (react_1.default.createElement(atoms_1.Shadow, Object.assign({}, shadowProps), children)) : (react_1.default.createElement(react_1.default.Fragment, null, children))));
};
